import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings" }
const _hoisted_2 = { class: "grid-x" }
const _hoisted_3 = { class: "cell small-12 xxlarge-10" }

import { NCard } from 'naive-ui'
import SettingsForm from "@/components/client/SettingsForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SettingsForm)
      ])
    ])
  ]))
}
}

})